export default {
  updatedReason: 'initial',
  zeroOrderTotal: false,
};
